module.exports = __webpack_public_path__ + "img/income-trend.5c2613bc.svg";